<template>
  <div class="screen-responder" :class="{'filter-blur':activitymoadal==true}">
      <div v-if="!isEnded">
       <div v-for="(student,studentIndex) in studentList" :key="studentIndex" class="student-item">
          <img class="student-headImg" :src="getImg(student.avatar)" alt="student"/>
          <div class="student-name" :title="student.name">
            <div><span>{{student.name}}</span></div>
          </div>
          <div class="select-area" @mouseenter="showOrHideSelectList(studentIndex,true)" @mouseleave="showOrHideSelectList(studentIndex,false)">
            <button class="select-btn" type="button" v-show="!student.isSelect" :class="{'no-score':student.score<=0}">
              <span class="select-text" v-text="!student.score||student.score<=0?'打分':student.score+'分'"></span>
              <span class="iconfont icon-sanjiao"></span>
            </button>
            <ul class="select-list" v-show="student.isSelect" v-scrollBar>
              <li v-for="(item,index) in 10" :key="index" :value="10-index" @click="remark(studentIndex,10-index)">{{10-index}}分</li>
            </ul>
          </div>
          <i class="student-del iconfont icon-qiapianguanbi" @click="delStudent(studentIndex)"></i>
      </div>
      <div class="student-item no-student" v-for="(item,index) in (studentsNum-studentList.length)" :key="'no-student'+index">
           <div class="student-headImg"><img src="../../common/img/undo.png" alt=""></div>
           <div class="student-name">
              <div><span>待加入</span></div>
           </div>
      </div>
    </div>
    <div v-else>
       <div v-for="(student,index) in studentList" :key="'no-'+index" class="student-item result-student-item" :class="showScoreSort(index)">
          <p class="student-order" v-if="index<3">{{index+1}}</p>
          <img class="student-headImg" :src="getImg(student.avatar)" alt="student"/>
          <div class="student-name" :title="student.name">
            <div><span>{{student.name}}</span></div>
          </div>
          <p class="student-score">{{student.score > 0 ? student.score + '分':'0分'}}</p>
          <svg class="iconfont" v-if="index==0">
              <use xlink:href="#icon-qiapiandiyi"></use>
          </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'responder',
  props:{activitymoadal:Boolean},
  data () {
    return {
       studentList:[],
       studentsNum:0,
       isEnded:true,
       timer: null
    }
  },
  methods:{
     init:function(){
        let self=this;
        self.userId=self.common.getCookie("userId");
        self.activityId=self.common.getCookie("activityId");
        self.batch=null;
        self.getDetail();
        self.timer = setInterval(() =>{         
          self.getDetail();
        },2000);
     },
     getBatch:function(){
        let self=this;
        self.$http.get(self.baseURL1+'/interlocution/getBatchList',{interlocutionId:self.activityId}).then((res)=>{
           self.batch=res.data.batch;
        });
     },
     getDetail:function(){
        let self=this;
        let params={
          userId:self.userId,
          interlocutionId:self.activityId,
          role:8,
          batch:self.batch
        };
        self.$http.get(self.baseURL1+'/interlocution/getDetail',{params:params}).then((res)=>{
             let data=res.data;
             self.$emit('pushDetial',data);
             self.studentsNum=data.allCount;
             self.batch=data.batch;
             self.isEnded=data.complete == 1;
             let allStudentList=data.students?data.students:[];
             if(self.isEnded){
                for(let i=0;allStudentList&&i<allStudentList.length;i++){
                  for(let j=allStudentList.length-1;j>i;j--){
                    if(allStudentList[i].score<=allStudentList[j].score){
                      let student=allStudentList[i];
                      allStudentList[i]=allStudentList[j];
                      allStudentList[j]=student;
                    }
                  }
                }
              //  clearInterval(self.timer);    
             }
             if(allStudentList.length>10){allStudentList.splice(10);}
             self.studentList=allStudentList;
             
         });
     },
     showOrHideSelectList:function(i,v){
       let self=this;
       console.log(i);
       console.log(self.studentList[i]);
       self.provisionalClear(v);
       if(self.studentList[i].isSelect == undefined){
          self.$set(self.studentList[i],'isSelect',v);
       }else{
         self.studentList[i].isSelect=v;
         self.studentList.splice(i,1,self.studentList[i]);
       }
     },
     remark:function(i,score){
        let self=this;
        self.provisionalClear(true);
        self.studentList[i].score=score;
        self.studentList.splice(i,1,self.studentList[i]);
        self.showOrHideSelectList(i,false);
        let requestJson={
          users:[{
            userId:self.studentList[i].userId,
            growth:self.studentList[i].score
          }],
          interlocutionId:self.activityId
        };
        self.$http.post(self.baseURL1+'/interlocution/gradeForStudent',requestJson).then((res)=>{
             self.provisionalClear(false);
        });
     },
     delStudent:function(i){
       let self=this;
       self.provisionalClear(true);
       let studentId=self.studentList[i].userId;
       self.studentList.splice(i,1);
       self.$http.post(self.baseURL1+'/interlocution/deleteStudent',{userId:studentId,interlocutionId:self.activityId}).then((res)=>{
            self.provisionalClear(false);
       })
     },
     showScoreSort:function(i){
       switch(i){
         case 0:return 'first ranking';break;
         case 1:return 'second ranking';break;
         case 2:return 'third ranking';break;
         default:return '';
       }
     },
     provisionalClear:function(isClear){
         let self=this;
         clearInterval(self.timer); 
         self.timer = null;
         if(!isClear){
         self.timer = setInterval(() =>{         
          self.getDetail();
         },2000);
       }
     },
     getImg(imgUrl){
      return this.common.handleImg(imgUrl,this.rescourceURL);
    }  
  },
  created:function(){
    this.init();
  },
  watch:{
    '$route': 'init',
    studentListCopy(newVal,oldVal){
      
    }
  },
  computed:{
     
  },
  beforeDestroy() {
     clearInterval(this.timer);        
     this.timer = null;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "responder.scss"
</style>



// WEBPACK FOOTER //
// src/components/responder/responder.vue